import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#07070B] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full border-2 border-purple-500/30 border-t-purple-500 animate-spin" />
          <p className="text-slate-400 font-mono text-sm tracking-widest uppercase">Checking who's on...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.onboarding_complete === false && !window.location.pathname.includes("/onboarding")) {
    return <Navigate to="/onboarding" replace />;
  }

  if (adminOnly && user.role !== "admin") return <Navigate to="/lobby" replace />;

  return children;
}
